var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"top":"","color":_vm.alerta.tipo == 'alerta'
      ? 'warning'
      : _vm.alerta.tipo == 'error'
      ? 'error'
      : 'success'},scopedSlots:_vm._u([{key:"action",fn:function(ref){
      var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"color":"black","icon":""},on:{"click":function($event){_vm.alerta.estado = false}}},'v-btn',attrs,false),[_c('v-icon',[_vm._v("mdi-close")])],1)]}}]),model:{value:(_vm.alerta.estado),callback:function ($$v) {_vm.$set(_vm.alerta, "estado", $$v)},expression:"alerta.estado"}},[_c('div',{staticClass:"text-center mx-auto"},[_c('h2',[_vm._v(_vm._s(_vm.alerta.titulo))]),_c('span',[_vm._v(" "+_vm._s(_vm.alerta.info)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }